
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/sub-roles",
      function () {
        return require("private-next-pages/account/sub-roles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/sub-roles"])
      });
    }
  